import { useState } from "react";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { PageHeader } from "@/components/common/PageHeader";
import { useAuth } from "@/auth/useAuth";
import { PaymentsTab } from "./tabs/PaymentsTab";
import { DebtsTab } from "./tabs/DebtsTab";
import { ExpensesTab } from "./tabs/ExpensesTab";
import { SalaryTab } from "./tabs/SalaryTab";
import { ReportTab } from "./tabs/ReportTab";
import { WriteOffsTab } from "./tabs/WriteOffsTab";
import { CashReconciliationTab } from "./tabs/CashReconciliationTab";
import Button from "@mui/material/Button";
import { FinanceExportDialog } from "./FinanceExportDialog";
import { useTranslation } from "react-i18next";

interface TabDef {
  key: string;
  label: string;
  permission: "fin.payments" | "fin.debts" | "fin.expense" | "fin.salary" | "fin.report" | "fin.writeoff" | "fin.reconcile";
}

const TAB_DEFS: TabDef[] = [
  { key: "payments", label: "Оплаты", permission: "fin.payments" },
  { key: "debts", label: "Задолженности", permission: "fin.debts" },
  { key: "expenses", label: "Расходы", permission: "fin.expense" },
  { key: "salary", label: "Зарплаты", permission: "fin.salary" },
  { key: "writeoffs", label: "Списание долгов", permission: "fin.writeoff" },
  { key: "reconciliation", label: "Сверка кассы", permission: "fin.reconcile" },
  { key: "report", label: "Отчёт P&L", permission: "fin.report" },
];

export function FinancePage() {
  const { hasPermission, user } = useAuth();
  const { t } = useTranslation();
  const availableTabs = TAB_DEFS.filter((t) => hasPermission(t.permission));
  const [activeKey, setActiveKey] = useState(availableTabs[0]?.key ?? "payments");
  const [exportOpen, setExportOpen] = useState(false);
  const canExport = user?.role === "DIRECTOR" || user?.role === "ACCOUNTANT";

  return (
    <>
      <PageHeader
        title={t("finance.title")}
        subtitle={t("finance.subtitle")}
        actions={canExport ? <Button variant="outlined" onClick={() => setExportOpen(true)}>Скачать XLSX</Button> : undefined}
      />
      <Paper className="crm-workspace-panel crm-finance" variant="outlined">
        <Tabs value={activeKey} onChange={(_, v) => setActiveKey(v)} variant="scrollable" scrollButtons={false}>
          {availableTabs.map((tabDef) => (
            <Tab key={tabDef.key} value={tabDef.key} label={t(`finance.${tabDef.key}`, { defaultValue: tabDef.label })} />
          ))}
        </Tabs>
        <Box className="crm-workspace-panel__body" p={3}>
          {activeKey === "payments" && <PaymentsTab />}
          {activeKey === "debts" && <DebtsTab />}
          {activeKey === "expenses" && <ExpensesTab />}
          {activeKey === "salary" && <SalaryTab />}
          {activeKey === "writeoffs" && <WriteOffsTab />}
          {activeKey === "reconciliation" && <CashReconciliationTab />}
          {activeKey === "report" && <ReportTab />}
        </Box>
      </Paper>
      {canExport && <FinanceExportDialog open={exportOpen} onClose={() => setExportOpen(false)} />}
    </>
  );
}
